import * as signalR from "@microsoft/signalr";

let connection: signalR.HubConnection | null = null;

export function getSignalRConnection(): signalR.HubConnection {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl("https://backendaiscworld-hbevgne7faaggqbr.eastus2-01.azurewebsites.net/notificationhub")
      .withAutomaticReconnect()
      .build();
  }
  return connection;
}
